<template>
  <div>
    <div class="choix-date mt-5 mb-12 d-flex ">
      <div class="mr-12">
        <HistoriqueCommandes :periode="periode"/>
      </div>

      <div class="ml-12">
        <div class="client-filter mb-4">
          <v-autocomplete
            v-model="selectedClientId"
            :items="clientsWithAll"
            item-text="name"
            item-value="id"
            label="Filtrer par client"
            placeholder="Tous les clients"
            outlined
            dense
            clearable
            :menu-props="{ maxHeight: 300 }"
          />
        </div>
        <div class="d-flex justify-space-around align-center flex-wrap">
          <v-date-picker class="" v-show="showFromPicker" v-model="periode.from_picker" locale="fr-FR"></v-date-picker>
          <v-date-picker class="" v-show="showToPicker" v-model="periode.to_picker" locale="fr-FR"></v-date-picker>
          <div class="">
            <v-btn rounded="" class="red" dark="" @click="fetchOrdersBetween">Rechercher</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HistoriqueCommandes from '../components/HistoriqueCommandes'
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {cmdType: {default: 1}},
  components: {
    HistoriqueCommandes
  },
  data: () => ({
    periode: {
      from_picker: new Date().toISOString().substr(0, 10),
      to_picker: new Date().toISOString().substr(0, 10),
    },
    showFromPicker: true,
    showToPicker: true,
    selectedClientId: null
  }),
  methods: {
    ...mapActions(['fetchOrders', 'fetchClients']),
    fetchOrdersBetween() {
      console.log({min: new Date(this.periode.from_picker).getTime(), max: new Date(this.periode.to_picker).setHours(23), clientId: this.selectedClientId})
      this.fetchOrders({
        min: new Date(this.periode.from_picker).getTime(),
        max: new Date(this.periode.to_picker).setHours(23),
        clientId: this.selectedClientId
      })
    }
  },
  computed: {
    ...mapGetters(['isAdminConnected', 'clients']),
    clientsWithAll() {
      return [
        { id: null, name: 'Tous les clients' },
        ...this.clients
      ]
    }
  },
  async created() {
    console.log('created commandes, cmdType ->', this.cmdType)
    await this.fetchClients()
  },
  watch: {
    /*from_picker(maj) {
      console.log(Date.parse(maj))
      console.log(maj)
    },
    to_picker(maj) {
      console.log(Date.parse(maj))
    }*/
  }

}
</script>

<style scoped>
  .pos-rel {
    position: relative;
  }
  .pos-abs {
    position: absolute;
  }
  .client-filter {
    width: 100%;
    max-width: 400px;
  }
</style>